import React from 'react';
import type { ChartGuide, ChartGuideListStyle } from '../../contexts/ChartGuideContext';

const sectionHeadingClass = 'text-lg sm:text-xl font-semibold text-text-primary mb-2';
const bodyTextClass = 'text-text-secondary leading-relaxed';
const listItemClass = `${bodyTextClass} ps-1`;

const getListClassName = (style: ChartGuideListStyle = 'bullet') => {
  if (style === 'decimal') {
    return 'list-decimal list-outside mr-6 space-y-3';
  }
  if (style === 'bullet') {
    return 'list-disc list-outside mr-6 space-y-3';
  }
  return 'space-y-3';
};

interface ChartGuideBodyProps {
  guide: ChartGuide;
}

const ChartGuideBody: React.FC<ChartGuideBodyProps> = ({ guide }) => {
  const ListTag = (style: ChartGuideListStyle = 'bullet') => (style === 'decimal' ? 'ol' : 'ul');

  return (
    <div className="space-y-8">
      {guide.description?.trim() ? (
        <section>
          <h3 className={sectionHeadingClass}>توضیحات</h3>
          <p className={bodyTextClass}>{guide.description}</p>
        </section>
      ) : null}

      {guide.interpretation?.trim() ? (
        <section>
          <h3 className={sectionHeadingClass}>نحوه تفسیر</h3>
          <p className={bodyTextClass}>{guide.interpretation}</p>
        </section>
      ) : null}

      {guide.sections?.map((section, sectionIndex) => {
        const style = section.style ?? 'bullet';
        if (style === 'none') {
          return (
            <section key={`${section.title}-${sectionIndex}`}>
              <h3 className={sectionHeadingClass}>{section.title}</h3>
              <div className="space-y-3">
                {section.items.map((item, itemIndex) => (
                  <p key={itemIndex} className={bodyTextClass}>
                    {item}
                  </p>
                ))}
              </div>
            </section>
          );
        }

        const Tag = ListTag(style);
        return (
          <section key={`${section.title}-${sectionIndex}`}>
            <h3 className={sectionHeadingClass}>{section.title}</h3>
            <Tag className={getListClassName(style)}>
              {section.items.map((item, itemIndex) => (
                <li key={itemIndex} className={listItemClass}>
                  {item}
                </li>
              ))}
            </Tag>
          </section>
        );
      })}

      {!guide.sections?.length && guide.tips && guide.tips.length > 0 ? (
        <section>
          <h3 className={sectionHeadingClass}>نکات کلیدی</h3>
          <ul className={getListClassName('bullet')}>
            {guide.tips.map((tip, index) => (
              <li key={index} className={listItemClass}>
                {tip}
              </li>
            ))}
          </ul>
        </section>
      ) : null}
    </div>
  );
};

export default ChartGuideBody;
